<template>
  <vs-row class="name-sign-row mt-4">
    <!-- 작성자 영역 -->
    <vs-col vs-type="flex" vs-align="center" vs-lg="4" vs-sm="6" vs-xs="12" class="mb-3 mb-lg-0">
      <vs-row vs-align="center" class="w-full">
        <vs-col vs-type="flex" vs-lg="4" class="label text-right pr-3">{{ labelName }}</vs-col>
        <vs-col vs-type="flex" vs-lg="8">
          <ml-input v-if="!isPrint" class="w-full mr-8" v-model="localName" :readonly="readonly" @input="$emit('update:name', localName)" />
          <span v-else class="print-input mr-8">{{ localName }}</span>
        </vs-col>
      </vs-row>
    </vs-col>

    <!-- 서명 영역 -->
    <vs-col vs-type="flex" vs-align="center" vs-lg="4" vs-sm="6" vs-xs="12">
      <vs-row vs-align="center" class="w-full">
        <vs-col vs-type="flex" vs-lg="4" class="label text-right pr-3">{{ labelSignature }}</vs-col>
        <vs-col vs-type="flex" vs-lg="8">
          <sign-field v-if="!isPrint && !readonly"  v-model="localSignature" class="signature-component" @input="$emit('update:signature', localSignature)"/>
          <div v-else class="w-full text-center mx-auto">
            <div v-if="localSignature" class="signature-image" :style="{backgroundImage: localSignature? `url(${localSignature})`: ''}"></div>
            <div v-else class="signature-image">
              <span>{{ emptyMessage }}</span>
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vs-col>
  </vs-row>
</template>

<script>
import SignField from "@/components/SignField.vue";

/**
 * 2024-03-11
 * gsnd 438 템플릿에서 처음 개발되었음
 * 관련 카드 : https://app.clickup.com/t/86entaz4a
 */
export default {
  name: 'NameWithSignatureRow',
  components: {
    SignField
  },
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    isPrint: {
      type: Boolean,
      default: false
    },
    labelName: {
      type: String,
      default: '서명자'
    },
    labelSignature: {
      type: String,
      default: '서명'
    },
    name: {
      type: String,
      default: ''
    },
    /**
     * 서명 이미지 주소, 또는 Base64 문자열
     */
    signature: {
      type: String,
      default: ''
    },
    /**
     * 서명이 없을 때 표시할 메시지
     */
    emptyMessage: {
      type: String,
      default: '-'
    }
  },
  data() {
    return {
      localName: this.name,
      localSignature: this.signature
    }
  },
  watch: {
    name (newVal) {
      this.localName = newVal;
    },
    signature (newVal) {
      this.localSignature = newVal;
    }
  },
}
</script>


<style scoped>
.label {
  font-weight: 500;
  font-size: 14px;
}

.signature-component {
  width: 250px;
  height: 80px;
}
.signature-image {
  display: flex;
  width: 250px;
  height: 80px;
  border: 1px dotted #cdcdcd;
  border-radius: 6px;
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  justify-content: center;
  align-items: center;
}
.signature-image span {
  display: inline-flex;
  color: #cdcdcd;
}

/* 모바일(한 줄에 한 칸씩 쌓이는 폭): 다른 입력 행(라벨 114px, 간격 16px, 나머지 입력칸)과 라벨 폭·시작 위치·입력칸 폭을 맞춘다 */
@media (max-width: 600px) {
  .name-sign-row .label {
    flex: 0 0 114px;
    width: 114px !important;
    max-width: 114px;
    margin-right: 16px;
    padding-right: 0 !important;
    text-align: left !important;
  }
  .name-sign-row .label + .vs-col {
    flex: 1 1 0;
    width: auto !important;
    min-width: 0;
  }
  .name-sign-row .label + .vs-col .mr-8 {
    margin-right: 0 !important;
  }
  .signature-component,
  .signature-image {
    width: 100%;
  }
}
</style>
